import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "./api";

const Ctx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const refresh = useCallback(async () => {
    if (!localStorage.getItem("dd_token")) {
      setUser(false);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(false);
    }
  }, []);
  useEffect(() => {
    refresh();
  }, [refresh]);
  const login = (token, u) => {
    localStorage.setItem("dd_token", token);
    setUser(u);
  };
  const logout = () => {
    localStorage.removeItem("dd_token");
    setUser(false);
  };
  return <Ctx.Provider value={{ user, setUser, login, logout, refresh }}>{children}</Ctx.Provider>;
}

export const useAuth = () => useContext(Ctx);
